module.exports = __webpack_public_path__ + "img/task-3.bab732a6.png";